<p class="infoText" style="background-color: #fff;">
  {{popoverText}}
</p>
